import { showErrorMessage } from "../commons/show-error-message";
import { displayInformation } from "./displays/allowance/display-information";
import { logError, addContextLog } from "../../infrastructure/log";
import { translate } from "../../infrastructure/translate/localization";
import { getAllowance } from "../../infrastructure/allowance-config-repository";

export async function calculateAmount({
  mealBenefit,
  transportBenefit,
  nurseryBenefit,
  model,
  recurrentSubsidy,
  alertId,
}) {
  try {
    let amount = 0;
    const { employeesItems, employeeIds } = getAllowance();
    employeeIds.forEach((id) => {
      const mealAmount = mealBenefit
        ? parseFloat(employeesItems[id].mealDays) *
          parseFloat(employeesItems[id].mealAmount)
        : 0;
      const transportAmount = transportBenefit
        ? parseFloat(employeesItems[id].transportAmount)
        : 0;
      const nurseryAmount = nurseryBenefit
        ? parseFloat(employeesItems[id].nurseryAmount)
        : 0;
      amount = amount + mealAmount + transportAmount + nurseryAmount;
    });

    displayInformation({
      totalAmount: amount,
      model,
      recurrentSubsidy,
      alertId,
    });

    const subsidy = {
      modelId: model.id,
      amount,
      employeeIds,
      recurrentSubsidy,
      alertId,
    };
    addContextLog("info", "displayInformation", "display-screen", { subsidy });
  } catch (e) {
    logError(e, `Error to calculateAmount for ${model.id}`);
    showErrorMessage(translate("common-messages.basic-error-message"), true, e);
  }
}
